import React, { useState, useEffect } from "react"
import { apiFetch } from "./apiClient"

const HERO_WORDS = ["Smarter", "Faster", "Autonomously", "24/7"]

function Homepage({ onUnlockBeta }) {
  const [backendText, setBackendText] = useState(
    "Empowering retail investors with institutional-grade market intelligence and automated trading capabilities."
  )
  const [displayText, setDisplayText] = useState("")
  const [wordIndex, setWordIndex] = useState(0)
  const [isDeleting, setIsDeleting] = useState(false)
  const [pause, setPause] = useState(false)

  useEffect(() => {
    apiFetch("/startup-info")
      .then((res) => res.text())
      .then((data) => {
        setBackendText(data)
      })
      .catch(() => {
        console.log("Backend not connected, using default text")
      })
  }, [])

  useEffect(() => {
    if (pause) {
      const pauseTimer = setTimeout(() => setPause(false), 1200)
      return () => clearTimeout(pauseTimer)
    }

    const current = HERO_WORDS[wordIndex % HERO_WORDS.length]
    const delta = isDeleting ? 55 : 90

    const timer = setTimeout(() => {
      const nextText = isDeleting
        ? current.slice(0, Math.max(displayText.length - 1, 0))
        : current.slice(0, displayText.length + 1)
      setDisplayText(nextText)

      if (!isDeleting && nextText === current) {
        setPause(true)
        setIsDeleting(true)
      } else if (isDeleting && nextText === "") {
        setIsDeleting(false)
        setWordIndex((prev) => (prev + 1) % HERO_WORDS.length)
      }
    }, delta)

    return () => clearTimeout(timer)
  }, [displayText, isDeleting, wordIndex, pause])

  const handleBetaUnlock = () => {
    if (onUnlockBeta) {
      onUnlockBeta()
    }
  }

  return (
    <div className="relative min-h-screen bg-white text-purple-900 overflow-hidden">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-10 -left-16 w-80 h-80 bg-gradient-to-br from-purple-100 via-purple-50 to-white blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-tr from-fuchsia-100 via-purple-50 to-white blur-3xl"></div>
        <div className="absolute inset-x-0 top-32 h-px bg-gradient-to-r from-transparent via-purple-200/50 to-transparent"></div>
      </div>

      <main className="relative z-10 max-w-4xl mx-auto px-6 pb-20 text-center">
        <div className="space-y-4 pt-10">
          <p className="text-xs uppercase tracking-[0.35em] text-purple-500">Neo Beta</p>
          <h1 className="text-4xl md:text-5xl font-bold leading-tight">
            Investing, Done{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-700 via-fuchsia-600 to-purple-500">
              {displayText}
            </span>
          </h1>
          <p className="text-lg text-purple-800/80 max-w-3xl mx-auto">{backendText}</p>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={handleBetaUnlock}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl text-white font-semibold bg-purple-700 hover:bg-purple-800 transition-colors"
          >
            Try our beta version
            <span aria-hidden="true">→</span>
          </button>
        </div>

        <div className="mt-12">
          <div className="rounded-2xl border border-purple-100 bg-white p-6 shadow-sm text-left space-y-3">
            <p className="text-xs font-semibold text-purple-500">Beta Features</p>
            <p className="text-sm text-purple-800/80">
              What you get right now: curated market intelligence.
            </p>
            <ul className="list-disc list-inside text-sm text-purple-800/80 space-y-1">
              <li>Neo agentic team delivers on-demand AI reports tailored to your portfolio.</li>
              <li>Actionable market signals distilled to the essentials you need to decide.</li>
            </ul>
          </div>
        </div>
      </main>
    </div>
  )
}

export default Homepage
